import { render, staticRenderFns } from "./r-input-number.vue?vue&type=template&id=96c6e6a8&scoped=true&"
import script from "./r-input-number.vue?vue&type=script&lang=js&"
export * from "./r-input-number.vue?vue&type=script&lang=js&"
import style0 from "./r-input-number.vue?vue&type=style&index=0&id=96c6e6a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c6e6a8",
  null
  
)

export default component.exports